"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMAIN_VERSION = void 0;
/** Current version of the shared domain contract. */
exports.DOMAIN_VERSION = '0.0.0';
//# sourceMappingURL=version.js.map